var _circle, _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoise(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 49.5,
    fill: "#F8F7FF",
    stroke: "url(#paint0_linear_1062_75)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1062_75)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60 50C60 46.4 57 43.8333 55.5 43H42V56.5H55.5C59.5 54.5 60.1667 51.3333 60 50Z",
    fill: "#393184"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 50C60 46.4 57 43.8333 55.5 43H42V56.5H55.5C59.5 54.5 60.1667 51.3333 60 50Z",
    stroke: "url(#paint1_linear_1062_75)",
    strokeWidth: 0.5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_1062_75)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.158 34.6023L33.8351 39.1989V49.7881V60.3773L43.183 64.9794C49.4189 68.0494 52.6334 69.5814 52.8392 69.5814C53.2535 69.5814 53.5037 69.4358 53.6861 69.0885C53.8199 68.8337 53.8379 66.5514 53.8379 49.7881C53.8379 33.0248 53.8199 30.7425 53.6861 30.4877C53.4997 30.1327 53.2501 29.9931 52.8143 30.0003C52.5826 30.004 49.6374 31.4077 43.158 34.6023ZM61.8193 33.4881C59.8947 34.7897 59.6581 35.036 59.8634 35.5239C59.9298 35.6816 60.4323 36.1292 61.0787 36.606C61.6848 37.0532 62.1794 37.4521 62.1778 37.4924C62.1761 37.5328 61.7378 37.8552 61.2039 38.209C59.7985 39.1401 59.5668 39.3559 59.5706 39.7286C59.5723 39.8998 59.6325 40.1161 59.7044 40.2092C59.8761 40.4318 60.3242 40.5949 60.5465 40.5157C60.7686 40.4366 63.8588 38.3567 64.1707 38.0764C64.3519 37.9135 64.3952 37.7832 64.3717 37.4699C64.3432 37.0879 64.2938 37.035 63.2176 36.2297C62.5992 35.767 62.0718 35.3662 62.0457 35.339C62.0196 35.3118 62.5566 34.911 63.2391 34.4483C64.752 33.4227 64.9873 33.046 64.4469 32.514C64.0065 32.0802 63.7733 32.1666 61.8193 33.4881ZM27.4775 39.7014C26.9879 39.9822 27 39.7243 27 49.7897C27 56.5277 27.0319 59.2643 27.1123 59.4191C27.3939 59.9611 27.4745 59.9771 29.9401 59.9795L32.2269 59.9816V49.7881V39.5946L29.9401 39.5975C28.5747 39.5994 27.5825 39.6412 27.4775 39.7014ZM67.7549 45.4786C67.4609 45.768 67.4552 45.9079 67.675 47.4382C67.7669 48.0781 67.8135 48.6297 67.7786 48.664C67.7439 48.6984 67.0566 48.6082 66.2516 48.4637C65.0711 48.2518 64.7447 48.2236 64.5648 48.318C64.0372 48.5947 63.9345 49.1486 64.3374 49.5451C64.4731 49.6787 64.6271 49.7881 64.6796 49.7881C64.7322 49.7881 65.6233 49.9463 66.6599 50.1395C68.8274 50.5437 69.1602 50.5466 69.4496 50.1633L69.6521 49.8952L69.4474 48.4809C69.3348 47.703 69.2521 47.0553 69.2636 47.0416C69.275 47.0279 69.8911 47.1277 70.6327 47.2634C71.3743 47.399 72.1006 47.5104 72.2464 47.5109C72.8841 47.5132 73.2361 46.7609 72.8196 46.286C72.6035 46.0395 72.4078 45.9853 70.4359 45.6266C69.2543 45.4115 68.2232 45.2356 68.1445 45.2356C68.0659 45.2356 67.8906 45.345 67.7549 45.4786ZM60.8916 58.2313C60.4823 58.6603 60.5824 58.911 61.9362 60.8473C63.2638 62.746 63.4175 62.8847 63.9786 62.6905C64.2004 62.6137 64.8514 61.8592 65.7859 60.5962L65.9678 60.3503L66.8422 61.5995C67.9158 63.1331 68.1669 63.2969 68.751 62.8445C69.2625 62.4485 69.1526 62.1349 67.8478 60.2653C66.7238 58.6549 66.3263 58.2003 66.0418 58.2003C65.7059 58.2003 65.3901 58.4835 64.6519 59.4468C64.2143 60.0179 63.8213 60.5064 63.7786 60.5323C63.7359 60.5583 63.3141 60.0269 62.8413 59.3513C62.3684 58.6758 61.9096 58.0959 61.8216 58.0627C61.4904 57.9376 61.1053 58.0075 60.8916 58.2313Z",
    fill: "url(#paint2_linear_1062_75)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.158 34.6023L33.8351 39.1989V49.7881V60.3773L43.183 64.9794C49.4189 68.0494 52.6334 69.5814 52.8392 69.5814C53.2535 69.5814 53.5037 69.4358 53.6861 69.0885C53.8199 68.8337 53.8379 66.5514 53.8379 49.7881C53.8379 33.0248 53.8199 30.7425 53.6861 30.4877C53.4997 30.1327 53.2501 29.9931 52.8143 30.0003C52.5826 30.004 49.6374 31.4077 43.158 34.6023ZM61.8193 33.4881C59.8947 34.7897 59.6581 35.036 59.8634 35.5239C59.9298 35.6816 60.4323 36.1292 61.0787 36.606C61.6848 37.0532 62.1794 37.4521 62.1778 37.4924C62.1761 37.5328 61.7378 37.8552 61.2039 38.209C59.7985 39.1401 59.5668 39.3559 59.5706 39.7286C59.5723 39.8998 59.6325 40.1161 59.7044 40.2092C59.8761 40.4318 60.3242 40.5949 60.5465 40.5157C60.7686 40.4366 63.8588 38.3567 64.1707 38.0764C64.3519 37.9135 64.3952 37.7832 64.3717 37.4699C64.3432 37.0879 64.2938 37.035 63.2176 36.2297C62.5992 35.767 62.0718 35.3662 62.0457 35.339C62.0196 35.3118 62.5566 34.911 63.2391 34.4483C64.752 33.4227 64.9873 33.046 64.4469 32.514C64.0065 32.0802 63.7733 32.1666 61.8193 33.4881ZM27.4775 39.7014C26.9879 39.9822 27 39.7243 27 49.7897C27 56.5277 27.0319 59.2643 27.1123 59.4191C27.3939 59.9611 27.4745 59.9771 29.9401 59.9795L32.2269 59.9816V49.7881V39.5946L29.9401 39.5975C28.5747 39.5994 27.5825 39.6412 27.4775 39.7014ZM67.7549 45.4786C67.4609 45.768 67.4552 45.9079 67.675 47.4382C67.7669 48.0781 67.8135 48.6297 67.7786 48.664C67.7439 48.6984 67.0566 48.6082 66.2516 48.4637C65.0711 48.2518 64.7447 48.2236 64.5648 48.318C64.0372 48.5947 63.9345 49.1486 64.3374 49.5451C64.4731 49.6787 64.6271 49.7881 64.6796 49.7881C64.7322 49.7881 65.6233 49.9463 66.6599 50.1395C68.8274 50.5437 69.1602 50.5466 69.4496 50.1633L69.6521 49.8952L69.4474 48.4809C69.3348 47.703 69.2521 47.0553 69.2636 47.0416C69.275 47.0279 69.8911 47.1277 70.6327 47.2634C71.3743 47.399 72.1006 47.5104 72.2464 47.5109C72.8841 47.5132 73.2361 46.7609 72.8196 46.286C72.6035 46.0395 72.4078 45.9853 70.4359 45.6266C69.2543 45.4115 68.2232 45.2356 68.1445 45.2356C68.0659 45.2356 67.8906 45.345 67.7549 45.4786ZM60.8916 58.2313C60.4823 58.6603 60.5824 58.911 61.9362 60.8473C63.2638 62.746 63.4175 62.8847 63.9786 62.6905C64.2004 62.6137 64.8514 61.8592 65.7859 60.5962L65.9678 60.3503L66.8422 61.5995C67.9158 63.1331 68.1669 63.2969 68.751 62.8445C69.2625 62.4485 69.1526 62.1349 67.8478 60.2653C66.7238 58.6549 66.3263 58.2003 66.0418 58.2003C65.7059 58.2003 65.3901 58.4835 64.6519 59.4468C64.2143 60.0179 63.8213 60.5064 63.7786 60.5323C63.7359 60.5583 63.3141 60.0269 62.8413 59.3513C62.3684 58.6758 61.9096 58.0959 61.8216 58.0627C61.4904 57.9376 61.1053 58.0075 60.8916 58.2313Z",
    stroke: "url(#paint3_linear_1062_75)",
    strokeWidth: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1062_75",
    x: 39.85,
    y: 40.85,
    width: 22.3225,
    height: 17.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.95
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1062_75"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1062_75",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_1062_75",
    x: 24.85,
    y: 27.85,
    width: 50.301,
    height: 43.8811,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.95
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1062_75"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1062_75",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1062_75",
    x1: 50,
    y1: 0,
    x2: 50,
    y2: 100,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DEDAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1062_75",
    x1: 52.5134,
    y1: 45.25,
    x2: 56.5826,
    y2: 57.9259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B7AFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1062_75",
    x1: 31.9225,
    y1: 33.6519,
    x2: 78.1469,
    y2: 61.4675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0A5FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447036,
    stopColor: "#B0A5FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B0A5FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1062_75",
    x1: 53.8333,
    y1: 36.5969,
    x2: 67.1413,
    y2: 72.6843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1CDFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoise);
export default __webpack_public_path__ + "static/media/noise.e454764c5ea3e9d54c0d13ff25fb86bd.svg";
export { ForwardRef as ReactComponent };